import { SET_UNENROLLED_STUDENT_INFO_LOADING, SET_UNENROLLED_STUDENT_INFO_ERROR, SET_UNENROLLED_STUDENT_INFO, SET_UNENROLLED_STUDENT_INFO_RESET } from '../types'

const initialState = {
  isLoading: false,
  error: false,
  success: false,
  info: {},
  documents: []
}

export const unenrolledStudentSelectedInfo = (state = initialState, action ) => {
  switch (action.type) {
    case SET_UNENROLLED_STUDENT_INFO_LOADING:
      return{
        ...state,
        isLoading: true,
        error: false
      }
    case SET_UNENROLLED_STUDENT_INFO:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        error: false
      }

    case SET_UNENROLLED_STUDENT_INFO_ERROR:
      return{
        ...state,
        isLoading: false,
        error: true,
        message: action.payload.message
      }

  case SET_UNENROLLED_STUDENT_INFO_RESET: 
    return {
      ...state,
      isLoading: false,
      error: false,
      success: false
    }
  
    default:
      return state
  }
}